import SubscribeForm from "../SubscribeForm";

export default function CtaBanner({
  title,
  subtitle,
  cta,
  onCtaClick,
  variant = "candidat",
  userType,
  showInlineForm = true,
}) {
  const isCandidat = variant === "candidat";
  const resolvedUserType = userType || (isCandidat ? "candidat" : "recruteur");

  return (
    <div
      className={`rounded-2xl p-4 sm:p-8 md:p-12 text-center text-white bg-gradient-to-r ${
        isCandidat
          ? "from-brand-primary to-brand-accent1"
          : "from-brand-primaryDark to-brand-accent2"
      }`}
    >
      <h2 className="text-2xl sm:text-3xl font-bold mb-3">{title}</h2>
      <p className="text-white/90 mb-6 sm:mb-8 max-w-xl mx-auto">{subtitle}</p>

      {showInlineForm && (
        <div className="w-full max-w-lg mx-auto mb-6 bg-white rounded-xl p-4 sm:p-6 text-left text-gray-900">
          <SubscribeForm userType={resolvedUserType} compact />
        </div>
      )}

      {onCtaClick && !showInlineForm && (
        <button
          type="button"
          onClick={() => onCtaClick("banner")}
          className={`px-8 py-3 rounded-full font-semibold text-lg transition transform hover:scale-105 shadow-lg ${
            isCandidat
              ? "bg-white/20 text-white border border-white/40 hover:bg-white/30"
              : "bg-white/20 text-white border border-white/40 hover:bg-white/30"
          }`}
        >
          {cta}
        </button>
      )}
    </div>
  );
}
